import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/_components/ui'
import { formatCurrency } from '@/_helpers/currency'
import { formatPercentage } from '@/_helpers/percentage'
import { getLastPaymentDate } from '@/features/_helpers/application'
import { formatDate } from '@/features/_helpers/date'
import type { TExposedApplicationAggregateDTO } from '@doutorsim/shared/applications'

interface ApprovedAmountCardProps {
  application: TExposedApplicationAggregateDTO
}

export const ApprovedAmountCard = ({ application }: ApprovedAmountCardProps) => {
  if (!application) return null

  const proposal = application.proposal
  const approvedAmount = proposal?.disbursementAmount ? Number(proposal.disbursementAmount) : null
  const totalEffectiveCost = proposal?.totalAmountOwed ? Number(proposal.totalAmountOwed) : null
  const registerFeeRate = proposal?.registerFeeRate ? Number(proposal.registerFeeRate) : null
  const iofAmount = proposal?.iofAmount ? Number(proposal.iofAmount) : null

  const lastPaymentDate =
    application.firstPaymentDate && application.installmentCount
      ? getLastPaymentDate(new Date(application.firstPaymentDate), application.installmentCount)
      : null

  return (
    <div className="flex flex-col gap-2">
      <h2 className="text-base font-bold">Valor Aprovado</h2>

      {approvedAmount && (
        <p className="text-xl font-bold text-brand-green-primary-5">
          {formatCurrency(approvedAmount)}
        </p>
      )}

      {approvedAmount && !totalEffectiveCost && (
        <p className="text-xl font-bold text-brand-green-primary-5">
          {formatCurrency(approvedAmount)}
        </p>
      )}

      {!approvedAmount && !application?.requestedAmount && (
        <span className="text-xl font-bold text-brand-grayscale-12">R$ -</span>
      )}

      <Accordion type="single" collapsible>
        <AccordionItem value="item-1" className="border-none">
          <AccordionTrigger className="flex-none justify-normal gap-1 p-0 text-xs font-bold text-brand-green-primary-5">
            Ver detalhes
          </AccordionTrigger>
          <AccordionContent className="pt-2">
            <div className="flex flex-col gap-1 text-xs text-brand-grayscale-7">
              <p>
                Valor da parcela:{' '}
                {proposal?.installmentAmount
                  ? formatCurrency(Number(proposal.installmentAmount))
                  : '-'}
              </p>
              <p>
                Parcelamento:{' '}
                {application?.installmentCount ? `${application.installmentCount}x` : '-'}
              </p>
              <p>
                Juros:{' '}
                {proposal?.interestRate
                  ? `${formatPercentage(Number(proposal.interestRate))} a.m.`
                  : '-'}
              </p>
              <p>
                CET:{' '}
                {proposal?.effectiveInterestRate
                  ? `${formatPercentage(Number(proposal.effectiveInterestRate))} a.m.`
                  : '-'}
              </p>
              <p>TC: {registerFeeRate ? formatPercentage(registerFeeRate) : '-'}</p>
              <p>IOF: {iofAmount ? formatCurrency(iofAmount) : '-'}</p>
              <p>Valor financiado: {approvedAmount ? formatCurrency(approvedAmount) : '-'}</p>
              <p>Valor total: {totalEffectiveCost ? formatCurrency(totalEffectiveCost) : '-'}</p>
              <p>
                Primeira parcela:{' '}
                {application?.firstPaymentDate
                  ? formatDate(new Date(application.firstPaymentDate))
                  : '-'}
              </p>
              <p>Última parcela: {lastPaymentDate ? formatDate(lastPaymentDate) : '-'}</p>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  )
}
